<template>

<div>
  <div class="header-container">
    <h2>Histórico de Partes</h2>
    <work-order-filter v-model="filters" @click-search="filterWorkOrders" :typeList="2"/>
    <b-pagination v-model.number="paginator.page" @change="onPageChange" align="center" :per-page="paginator.perPage" :total-rows="paginator.totalElements"/>
  </div>
  <div class="fixed-table-container">
    <work-order-table :buttons="buttons" :items="paginator.content" :editable-status="canChangeStatus"
                      @clickShow="openShowModal" @click-delete="deleteWorkOrder" @click-edit-status="openEditStatusModal"
                      @sortChanged="onSortChange"/>
  </div>
  <show-work-order-modal ref="showModal" modal-id="showModal" :workOrder="selectedWorkOrder" @delete="deleteWorkOrder"/>
  <b-modal ref="deleteDialog" title="¿Está Seguro?" ok-title="Eliminar" cancel-title="Cancelar"
           ok-variant="danger" header-bg-variant="danger" header-text-variant="light">
    <p>¿Está seguro de que desea eliminar el parte?</p>
  </b-modal>
  <b-modal ref="editStatusModal" title="Cambiar Estado" ok-title="Guardar" cancel-title="Cancelar"
           ok-variant="primary" header-bg-variant="primary" header-text-variant="light">
    <b-form-group label="Estado">
      <b-form-select v-model="selectedValidationStatus" :options="statusOptions"/>
    </b-form-group>
  </b-modal>
</div>

</template>

<script>

import ShowWorkOrderModal from './partials/ShowWorkOrderModal'
import ModelSelect from '@/components/common/ModelSelect'
import WorkOrderFilter from './partials/WorkOrderFilter'
import WorkOrderTable from './partials/WorkOrderTable'
import {session} from '@/auth'
import api from '@/api/api'

export default {
  name: 'WorkOrderHistory',
  components: {
    ShowWorkOrderModal,
    WorkOrderFilter,
    WorkOrderTable,
    ModelSelect
  },
  created() {
    this.loadWorkOrders()
  },
  data() {
    return {
      paginator: {
        page: 1,
        perPage: 10,
        totalElements: 0,
        content: []
      },
      sort: 'workOrderDate,desc',
      selectedWorkOrder: {},
      workOrders: [],
      filters: {},
      selectedValidationStatus: null,
      statusOptions: [
        {text: 'Pendiente 1ª Validación', value: 'PENDING_FIRST_VALIDATION'},
        {text: 'Pendiente 2ª Validación', value: 'PENDING_SECOND_VALIDATION'},
        {text: 'Confirmado', value: 'CONFIRMATED'}
      ]
    }
  },
  computed: {
    buttons() {
      const buttons = ['show']
      if ((session.authorities != null) && session.authorities.includes('ROLE_WORK_ORDER_DELETE')) {
        buttons.push('delete')
      }

      return buttons
    },
    canChangeStatus() {
      return session.authorities.includes('ROLE_WORK_ORDER_EDIT_STATUS')
    }
  },
  methods: {
    onSortChange(context) {
      this.sort = context.sortBy && context.sortBy + ',' + (context.sortDesc ? 'desc' : 'asc')
      this.loadWorkOrders(1)
    },
    onPageChange(page) {
      this.loadWorkOrders(page)
    },
    filterWorkOrders() {
      this.loadWorkOrders(1)
    },
    loadWorkOrders(page = this.paginator.page) {
      return api.workOrder.history(this.getParams(page)).then(paginator => {
        this.paginator.content = paginator.content
        this.paginator.totalElements = paginator.totalElements
        this.paginator.page = page
      })
    },
    getParams(page) {
      return {
        ...this.filters,
        page: page - 1,
        size: this.paginator.perPage,
        sort: this.sort
      }
    },
    openShowModal(workOrder) {
      this.selectedWorkOrder = workOrder
      this.$refs.showModal.show()
    },
    deleteWorkOrder(workOrder) {
      this.$refs.deleteDialog.$off('ok') // very important. clear previous custom event listeners
      this.$refs.deleteDialog.$once('ok', () => {
        api.workOrder.delete(workOrder.id).then(() => {
          this.loadWorkOrders().then(() => this.$toastr('success', 'Parte Eliminado'))
        })
      })
      this.$refs.deleteDialog.show()
    },
    openEditStatusModal(workOrder) {
      this.selectedValidationStatus = workOrder.validationStatus
      const modal = this.$refs.editStatusModal
      modal.$off('ok')
      modal.$once('ok', () => { this.editValidationStatus(workOrder, this.selectedValidationStatus) })
      modal.show()
    },
    async editValidationStatus(workOrder, status) {
      await api.workOrder.editValidationStatus(workOrder.id, status)

      const label = this.statusOptions.find(item => item.value === status).text
      workOrder.validationStatus = status
      workOrder.statusLabel = label
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/workOrder/History.vue